import React from "react";
import "./Navbar.scss"
import logo from "../../assets/logo.png"
import Button from "../Button/Button";
import fb from "../../assets/icons/fb.svg"
import insta from "../../assets/icons/insta.svg"
import twitter from "../../assets/icons/twitter.svg"
import menu from "../../assets/icons/menu.svg"
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";



const Navbar = ({ selected, setIsMenuOpen }) => {
    const history = useHistory()
    const isComingSoon = window.location.pathname === "/coming-soon"
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "navbar")
    const leftComponent = page?.Components?.find((component) => component?.ID === "VirasatV2Default-Navbar")?.Props ?? null
    const linksComponent = isComingSoon ? [] : page?.Components?.find((component) => component?.ID === "VirasatV2Default-Navbar-link")?.Data ?? []
    const buttonComponent = page?.Components?.find((component) => component?.ID === "VirasatV2Default-Navbar-button")?.Props ?? null
    const dispatch = useDispatch()

    return (
        <div className="VirasatDefault-Navbar">
            <div className="VirasatDefault-Navbar-tab">
                <div className="logo-name-tab">
                    <div className="logo-name-tab-menu"
                        onClick={() => {
                            setIsMenuOpen(true)
                        }}>
                        <img alt="" src={menu} />
                    </div>
                    <div className="logo-name-tab-cont"
                        onClick={() => {
                            history.push("/")
                        }}>
                        <img alt="" className="logo-name-tab-cont-img" src={logo} />
                    </div>
                    {leftComponent && <div className="logo-name-tab-namecont"
                        onClick={() => {
                            history.push(leftComponent?.href)
                        }}>
                        <div className="logo-name-tab-namecont-title">
                            {leftComponent?.header}
                        </div>
                        <div className="logo-name-tab-namecont-sub">
                            {leftComponent?.subheader}

                        </div>
                    </div>}
                </div>
                <div className="VirasatDefault-Navbar-tab-center">
                    {linksComponent.map((page) => {
                        return (
                            <div className={`virasta-tab-nav ${selected === page.pageId ? "selected" : ""}`}
                                onClick={() => {
                                    if (page?.href?.includes("https://")) {
                                        if (page?.href && page?.href !== "") {
                                            window.open(page?.href, '_blank')
                                        }
                                        else {
                                            dispatch(setIsComing(true))

                                        }
                                    } else {
                                        history.push(page?.href)
                                    }
                                }}>
                                {page.title}
                            </div>
                        )
                    })}
                </div>
                <div className="VirasatDefault-Navbar-tab-right">
                    <div className="VirasatDefault-nav-social">
                        <img alt="" src={fb} className="VirasatDefault-nav-social-itm" />
                        <img alt="" src={twitter} className="VirasatDefault-nav-social-itm" />
                        <img alt="" src={insta} className="VirasatDefault-nav-social-itm" />

                    </div>
                    {!isComingSoon && buttonComponent && <div className="VirasatDefault-nav-btn">
                        <Button
                            text={buttonComponent?.buttonText}
                            isSecondary={true}
                            width={"max-content"}
                            onClick={() => {
                                if (buttonComponent?.href && buttonComponent?.href !== "") { window.location.href = buttonComponent?.href }
                                else {
                                    dispatch(setIsComing(true))
                                }
                            }} />
                    </div>}

                </div>
            </div>
        </div>
    )
}
export default Navbar